import { useContext } from "react";

import AuthContext from "./AuthUserContext";

export const useAuthUser = () => useContext(AuthContext);
